<div>
  <section class="mix">
    <input [disabled]="isDisabled" (click)="inputFile.click()" type="text" readonly placeholder="Seleccione archivo..."
      [(ngModel)]="fileName" [id]="inputId" class="p-inputtext p-component" [class]="className" />
    <button (click)="inputFile.click()" [disabled]="isDisabled" type="button" class="z-btn z-btn-form auto">{{
      fileName
      ? 'Cambiar
      archivo'
      : 'Elegir archivo'
      }}</button>
  </section>
  <input [accept]="extAllowed" (change)="getFileFromInput($event)" type="file" style="display: none" #inputFile />
</div>